import { translate as __ } from 'foremanReact/common/I18n';

export const ANSIBLE_KEY = 'Ansible';
export const SECONDARY_TABS = [
  { key: 'roles', title: __('Roles') },
  { key: 'variables', title: __('Variables') },
  { key: 'inventory', title: __('Inventory') },
  { key: 'jobs', title: __('Jobs') },
];



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_ansible-12.0.6/webpack/components/AnsibleHostDetail/constants.js